<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="24">
          <Col v-bind="grid">
            <FormItem label="搜索："  label-for="key">
              <Input search enter-button clearable placeholder="请输入" v-model="userForm.key" @on-search="userSearchs">
              </Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="cateInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="type">
          <span v-if="row.type==1">阅读</span>
          <span v-if="row.type==2">导读</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a @click="views(row.comments_id)">查看</a>
        </template>
        <template slot-scope="{ row, index }" slot="image">
          <div class="tabBox_img">
            <img :src="row.image ? row.image : require('@/assets/images/avatar.png')">
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <i-switch v-model="row.status" :value="row.status" :true-value="1" :false-value="0" @on-change="changeSwitch(row)">
          </i-switch>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <!--删除-->
    <modalSure ref="modalSure" title="套餐" :id="id" :modelApi="modelApi" @closeModal="closeModal"></modalSure>
  </div>
</template>

<script>
import { commentsList, delCate, changeStatus } from '@/api/comments'
import modalSure from '@/components/modalSure'
export default {
  name: 'goodsCateList',
  components: { modalSure },
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        key: '',
        pid: 0 // 正常商品分类
      },
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      modelApi: delCate,
      pidArr: [],
      id: 0,
      dataCount: 0,
      cateInfo: [],
      loading: false,
      columns2: [
        {
          title: '用户名',
          key: 'username',
          minWidth: 120
        },
        {
          title: '阅读/导读',
          slot: 'type',
          minWidth: 120
        },
        {
          title: '心得',
          key: 'comments',
          minWidth: 120
        },
        {
          title: '点赞',
          key: 'like',
          minWidth: 120
        },
        {
          title: '活动',
          key: 'activity_name',
          minWidth: 120
        },
        {
          title: '班级',
          key: 'className',
          minWidth: 120
        },
        {
          title: '状态',
          slot: 'status',
          minWidth: 120
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    this.categoryList()
  },
  methods: {
    categoryList () {
      this.loading = true
      commentsList(this.userForm).then(res => {
        let data = res.data
        this.cateInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.categoryList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.categoryList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    views (id) {
      this.$router.push({ path: '/admin/user/comments/' + id })
    },
    updateStatusModel () {
      this.reload()
    },
    closeModal () {
      this.categoryList()
    },
    // 上下架
    changeSwitch (row) {
      changeStatus(row.id).then(async res => {
        this.$Message.success(res.msg)
        this.categoryList()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    onChangeStatus () {
      this.categoryList()
    }
  }
}
</script>
